import React, {useEffect, useState} from 'react'
import {Stack} from '@mui/material'
import './index.scss'
import {InfoOutlined} from '@mui/icons-material'
import CPSModal from 'shared/CPSModal'

interface InfoTooltipProps {
    behaviour?: string
    type?: string
    title?: string
    content?: any
    className?: string
    isClosable?: boolean
}

const InfoTooltip = ({
    behaviour,
    title,
    content,
    type,
    className,
    isClosable
}: InfoTooltipProps) => {
    const [showInfoContent, setShowInfoContent] = useState<boolean>(false)
    const [infoContent, setInfoContent] = useState<boolean>(false)
    const tooltipClasses = behaviour === 'inline' ? 'tooltip-inline' : ''

    const _handleIconClick = () => {
        setShowInfoContent(true)
    }

    const _toggleInfoContent = () => {
        setShowInfoContent(false)
    }

    useEffect(() => {
        let modalBody: any
        if (type === 'modal') {
            modalBody = (
                <CPSModal
                    isModalOpen={showInfoContent}
                    className={className}
                    title={title}
                    content={content}
                    isClosable={isClosable}
                    handleModalClose={_toggleInfoContent}
                />
            )
        }
        setInfoContent(modalBody)
    }, [showInfoContent])

    return (
        <Stack
            className={`infoTooltip ${tooltipClasses}`}
            data-testid={behaviour === 'inline' ? 'tooltip-inline' : 'tooltip-default'}
        >
            <InfoOutlined onClick={() => _handleIconClick()} />
            {infoContent}
        </Stack>
    )
}

InfoTooltip.defaultProps = {
    behaviour: 'fixed',
    type: 'error',
    title: '',
    content: null,
    className: '',
    isClosable: false
}

export default InfoTooltip
